export default {
    header: {
        title: "放置少女クリエイター支援プロジェクト",
        loading: "加载中..."
    },
    desc: {
        0: "「放置少女クリエイター支援プロジェクト」是",
        1: "这是一个为了推广放置少女的项目，我们会邀请一些优秀的创作者加入我们的团队，共同建设一个完善的创作环境。",
        2: "「放置少女クリエイター支援プロジェクト」是",
        3: "这是一个为了推广放置少女的项目，我们会邀请一些优秀的创作者加入我们的团队，共同建设一个完善的创作环境。",
        4: "「放置少女クリエイター支援プロジェクト」是",
        5: "这是一个为了推广放置少女的项目，我们会邀请一些优秀的创作者加入我们的团队，共同建设一个完善的创作环境。",
        6: "「放置少女クリエイター支援プロジェクト」是",
    },
}
